import 'jquery';
import $ from 'jquery';
import { checkDateAvailability, convertDateFromRuLocales, convertFromRuLocaleDateList } from '../utils/Date';
import { TimeList } from './TimeList';
import { Preloader } from './Preloader';

export class TabsDatepicker {
    constructor(element, options) {
        this.element = element;
        this.element.tabsDatepicker = this;
        this.navigationElement = $(this.element).find('.js-tabs-datepicker-nav-button')[0];
        this.timeListElement = $(this.element).find('.js-tabs-datepicker-time-list')[0];
        this.timeList = new TimeList(this.element.querySelector('.tabs-datepicker-radio-time'));
        this.preloader = new Preloader(element);
        this.fillDates(undefined, { silent: true });
        this.initListeners();
    }

    fillDates(initialDate, options = {}) {
        const currentDate = initialDate || new Date();
        window.requestAnimationFrame(() => {
            const tabList = this.createDatesAndTab(currentDate);
            this.tabsElements.remove();
            $(tabList).appendTo(this.tabsContainer);
            const filteredTabList = $(tabList).filter((i, item) => {
                return !$(item).hasClass('disabled');
            });
            this.changeActiveTab(filteredTabList[0], options);
        });
    }

    createDatesAndTab(currentDate) {
        const dateList = [];
        const days = 14;
        for (let i = 0; i < days; i++) {
            const tab = $(this.tabsElements[0]).clone();
            $(tab).removeClass('active');
            this.fillTab(tab, this.setDate(i, currentDate));
            dateList.push(tab[0]);
        }
        return dateList;
    }

    setDate(dayCount, currentDate) {
        return new Date(currentDate.getTime() + dayCount * 24 * 60 * 60 * 1000);
    }

    toggleTab(tab, state) {
        if (state) {
            $(tab).addClass('disabled');
            this.getTabRadio(tab).attr('disabled', 'disabled');
        } else {
            $(tab).removeClass('disabled');
            this.getTabRadio(tab).removeAttr('disabled');
        }
    }

    fillTab(tab, date) {
        const tabDay = $(tab).find('.js-tabs-datepicker-day');
        const tabDate = $(tab).find('.js-tabs-datepicker-date');
        tabDay.text(date.toLocaleDateString('ru-RU', { weekday: 'short' }));
        tabDate.text(date.getDate());
        this.getTabRadio(tab).val(date.toLocaleDateString('ru-RU'));
        this.toggleTab(tab, !checkDateAvailability(this.availableDates, this.disabledDates, date));
    }

    getTabRadio(tab) {
        return $(tab).find('.js-tabs-datepicker-date-radio');
    }

    changeDate(newDate) {
        const newActiveTab = this.findTabElementByDate(newDate);
        if ($(newActiveTab).hasClass('disabled')) return;
        if (newActiveTab.length) {
            this.changeActiveTab(newActiveTab);
        } else {
            this.fillDates(newDate);
        }
        window.requestAnimationFrame(() => {
            this.navigateToActiveTab();
            $(this.element).trigger('date:changed');
        });
    }

    changeActiveTab(newActiveTab, options = {}) {
        $(this.activeTabElement).removeClass('active');
        $(newActiveTab).addClass('active');
        const inputElement = $(newActiveTab).find('input');
        inputElement.prop('checked', true);
        if (!options.silent) {
            this.fillTimeList(inputElement.val());
        }
    }

    findTabElementByDate(date) {
        return $(this.element)
            .find(`input[value="${date.toLocaleDateString('ru-RU')}"]`)
            .parent();
    }

    navigateToActiveTab() {
        if (!isElementVisible(this.activeTabElement)) {
            this.navigateToggle();
        }
    }

    navigateToggle(toEnd) {
        if (typeof toEnd !== 'boolean') {
            toEnd = !this.isNavigationEnd;
        }
        toEnd ? this.navigateRight() : this.navigateLeft();
    }

    navigateLeft() {
        this.navigationElement.classList.remove('navigation-end');
        this.tabsContainer.scroll({
            left: 0,
            behavior: 'smooth'
        });
        this.isNavigationEnd = false;
    }

    navigateRight() {
        this.navigationElement.classList.add('navigation-end');
        this.tabsContainer.scroll({
            left: this.tabsContainer.scrollWidth,
            behavior: 'smooth'
        });
        this.isNavigationEnd = true;
    }

    fillTimeList(date) {
        this.fetchTime(date)
            .then((response) => {
                this.preloader.hidePreloader();
                $(this.timeListElement).html('');
                if (response[0].ok) {
                    $(this.element).trigger('date:before-fill-time-list');
                    const newTimesList = [];

                    const timesList = response[0].data;

                    if (!timesList.length) {
                        $(this.timeListElement).html(response[1]);
                        return;
                    }

                    timesList.forEach((item) => newTimesList.push(this.timeList.fillElement(item)));

                    $(this.timeListElement).append(newTimesList);

                    $(this.element).trigger('date:fetch-success');
                    return;
                }

                $(this.element).trigger('date:fetch-error', {
                    error: response[1]
                });
            })
            .catch((error) => {
                $(this.element).trigger('date:fetch-error', {
                    error: error
                });
            });
    }

    fetchTime(date) {
        this.preloader.showPreloader();
        return $.ajax({
            type: 'GET',
            data: { date },
            dataType: 'json',
            url: '/zapisatsya_na_priem/apply_date/'
        });
    }

    get options() {
        return JSON.parse(this.element.dataset.options || '{}');
    }

    get disabledDates() {
        return convertFromRuLocaleDateList(this.options.datesDisabled);
    }

    get availableDates() {
        return convertFromRuLocaleDateList(this.options.datesAvailable);
    }

    get tabsElements() {
        return $(this.element).find('.js-tabs-datepicker-tab');
    }

    get tabsContainer() {
        return $(this.element).find('.js-tabs-datepicker-tab-list')[0];
    }

    get activeTabElement() {
        return $(this.element).find('.js-tabs-datepicker-tab.active')[0];
    }

    get currentDate() {
        return convertDateFromRuLocales(
            $(this.element)
                .find('.js-tabs-datepicker-tab.active .js-tabs-datepicker-date-radio')
                .val()
        );
    }

    getDate() {
        return new Date(this.currentDate);
    }

    initListeners() {
        this.initNavigationListener();
        this.initChangeListener();
    }

    initNavigationListener() {
        $(this.navigationElement).on('click.navigation', () => this.navigateToggle());
    }

    initChangeListener() {
        $(this.element).on('change.tab', '.js-tabs-datepicker-date-radio', (e) => {
            this.changeDate(new Date(convertDateFromRuLocales($(e.target).val())));
        });
    }

    destroy() {
        this.removeListeners();
        this.removeChangeListener();
        delete this.element.tabsDatepicker;
    }

    removeListeners() {
        this.removeNavigationListener();
        this.removeChangeListener();
    }

    removeChangeListener() {
        $(this.element).off('change.tab');
    }

    removeNavigationListener() {
        $(this.navigationElement).off('click.navigation');
    }
}

$('.js-tabs-datepicker').each((i, element) => {
    new TabsDatepicker(element);
});

function isElementVisible(element) {
    const elRect = element.getBoundingClientRect();
    const conRect = $(element)
        .parent()[0]
        .getBoundingClientRect();
    const elFloorRect = {
        x: Math.floor(elRect.x),
        y: Math.floor(elRect.y),
        width: Math.floor(elRect.width),
        height: Math.floor(elRect.height)
    };
    const conFloorRect = {
        x: Math.floor(conRect.x),
        y: Math.floor(conRect.y),
        width: Math.floor(conRect.width),
        height: Math.floor(conRect.height)
    };

    let result = false;
    if (
        elFloorRect.x >= conFloorRect.x &&
        elFloorRect.y >= conFloorRect.y &&
        elFloorRect.x + elFloorRect.width <= conFloorRect.x + conFloorRect.width &&
        elFloorRect.y + elFloorRect.height <= conFloorRect.y + conFloorRect.height
    ) {
        result = true;
    }
    return result;
}
